import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  setGameSettings: [],
  gameSettingsRefresh: 0,
  gameName: "",
};

export const gameSettingsSlice = createSlice({
  name: "gameSettings",
  initialState,
  reducers: {
    setGameSettings: (state, action) => {
      state.setGameSettings = action.payload;
    },
    gameSettingsRefresh: (state, action) => {
      state.gameSettingsRefresh = action.payload;
    },
    gameName: (state, action) => {
      state.gameName = action.payload;
    },
  },
});

// Export actions
export const { setGameSettings, gameSettingsRefresh, gameName } =
  gameSettingsSlice.actions;

// Export reducer
export default gameSettingsSlice.reducer;
